export default __webpack_public_path__ + "static/media/generic_service_image.e974f74c.png";